/**
 * function that copy given string
 * @param {string} toCopy - string that will be copied
 * @return {void}
 */
function copy(toCopy) {
  var tempInput, selection, range;

  try {
    tempInput = document.createElement('INPUT');
    document.body.append(tempInput);
    tempInput.setAttribute('value', toCopy);
    tempInput.setAttribute('readOnly', 'true');
    tempInput.setAttribute('contentEditable', 'true');
    tempInput.dataset['testId'] = 'copy-input';
    var isIOS = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || // iPad on iOS 13 detection
    navigator.userAgent.includes('Mac') && 'ontouchend' in document;

    if (isIOS) {
      range = document.createRange();
      range.selectNodeContents(tempInput);
      selection = window.getSelection();
      selection.addRange(range);
      tempInput.setSelectionRange(0, 999999);
    } else {
      tempInput.select();
    }

    var successful = document.execCommand('copy');

    if (!successful) {
      throw new Error('Copy command was unsuccessful');
    }
  } catch (e) {
    console.warn(e);
  } finally {
    if (selection) {
      selection.removeAllRanges();
    }

    if (tempInput) {
      document.body.removeChild(tempInput);
    }
  }
}

export { copy };
//# sourceMappingURL=copy_to_clipboard.js.map
